import { render, staticRenderFns } from "./Copywriting1.vue?vue&type=template&id=739921f1&scoped=true"
import script from "./Copywriting1.vue?vue&type=script&lang=js"
export * from "./Copywriting1.vue?vue&type=script&lang=js"
import style0 from "./Copywriting1.vue?vue&type=style&index=0&id=739921f1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739921f1",
  null
  
)

export default component.exports